import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { X } from "lucide-react";
import { api, fmtUS, fmtTime } from "@/lib/api";

export function OpenedAssignment() {
  const [sp, setSp] = useSearchParams();
  const [a, setA] = useState(null);
  const id = sp.get("open");
  useEffect(() => {
    if (!id) return;
    api.get(`/rotation/assignments/${id}`).then((r) => setA(r.data)).catch(() => setA(null));
  }, [id]);
  if (!id || !a) return null;
  return (
    <div className="mb-4 flex items-start justify-between rounded-xl border border-[#BFD4FF] bg-[#EAF4FF] px-4 py-3 text-sm dark:border-white/10 dark:bg-white/5" data-testid="opened-assignment">
      <div>
        <div className="mb-1 text-xs font-semibold uppercase text-[#283F91] dark:text-blue-300">Testing assignment</div>
        <div className="flex flex-wrap gap-x-5 gap-y-1 text-[#20336F] dark:text-blue-100">
          <span>Patient ID: <b data-testid="opened-assignment-patient">{a.athena_id}</b></span>
          <span>Service: <b>{a.service}</b></span>
          <span>Location: <b>{a.location_name}</b></span>
          <span>Assigned to: <b>{a.employee_name}</b></span>
          <span>By: <b>{a.created_by_name}</b></span>
          <span>Time: <b>{fmtUS(a.local_date)} {fmtTime(a.local_time)} ET</b></span>
          <span>Status: <b>{a.status}</b></span>
        </div>
      </div>
      <button className="rounded p-1 hover:bg-white/60" onClick={() => setSp({}, { replace: true })} data-testid="opened-assignment-close"><X size={14} /></button>
    </div>
  );
}
